module.exports = __webpack_public_path__ + "img/sponsors.31b336a8.png";